// console.log("default");

/* モーダル時背景をボカす */
window.enableBlurBody = () => {
  document.documentElement.classList.add("blur");
  document.body.classList.add("blur");
}
window.disableBlurBody = () => {
  document.documentElement.classList.remove("blur");
  document.body.classList.remove("blur");
}

window.addEventListener("load", () => {
    if (window.removeSiteLoading) {
      window.removeSiteLoading();
    }
  });